<template>
  <span class="drag-icon-wrap">
    <el-tooltip class="item" effect="dark" content="长按拖拽排序" placement="top">
      <span class="el-icon-Group-50 drag-icon"></span>
    </el-tooltip>
  </span>
</template>

<script>
export default {
  name: 'drag-item-content',
};
</script>

<style lang="scss" scoped>
.drag-icon {
  font-size: 20px;
  margin-left: 5px;
  color: #797979;
  font-weight: bold;
  cursor: move;
}
</style>
